<script setup>
import MainPageProfessorsSlider from '@/components/slider/MainPageProfessorsSlider.vue'
</script>

<template>
  <v-container tag="section" class="cl__section__margin__bottom">
    <v-row :class="[$vuetify.display.mdAndUp ? 'mb-8' : '']">
      <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
        <h1 class="font-weight-bold cl-section__title" :class="[!$vuetify.display.mdAndDown ? 'mb-10' : '']" style="color: rgba(104, 109, 122, 1)">
          با <span class="text-dark">اساتید کلاسینو</span> آشنا شو
        </h1>

        <p class="cl__section__subtitle">
          اساتید ما رتبه‌های برتر کنکور و متخصصین آموزش هستن که سال‌ها تجربه‌ی قبولی دانش‌آموزان در بهترین مدارس و دانشگاه‌ها رو دارن. اینجا قرار نیست فقط درس بخونی، قراره راه‌ورسم موفقیت رو از اساتید کلاسینو یاد بگیری و به هر <strong>هدف تحصیلی</strong> که داری برسی.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <MainPageProfessorsSlider resource="home"></MainPageProfessorsSlider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn
          size="large"
          color="#155EEF"
          class="rounded-lg my-4 text-decoration-none"
          :to="{ name: 'professors' }"
          style="letter-spacing: 0"
          :width="$vuetify.display.mdAndDown ? '100%' : ''"
        >
          مشاهده همه اساتید
          <v-icon icon="$mdiChevronLeftBoxOutline" class="mx-2"></v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
</style>
